export const TYPE_IMAGEN = 'image';
export const TYPE_VIDEO = 'video';
